export default __webpack_public_path__ + "static/figma-frame-49ee4b57ad8c60d6a9ac733cb12986cc.gif";